import { useQuery } from "react-query";
import { getInvoices } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useGetInvoices = () => {
  return useQuery("GetInvoices", getInvoices, {
    refetchOnWindowFocus: false,
  });
};
